(function (f, u, ll, view) {
  f = 'https://install.eu1.fullview.io';
  u = document;
  ll = 'script';
  view = u.createElement(ll);
  view.src = f;
  view.async = true;
  view.setAttribute('data-org', '7b6ce4bf-186c-4d5c-9e85-70afd82f79f2');
  f = u.getElementsByTagName(ll)[0];
  f.parentNode.insertBefore(view, f);
})();
